import { render, staticRenderFns } from "./radarChar.vue?vue&type=template&id=271bf2b9&scoped=true"
import script from "./radarChar.vue?vue&type=script&lang=js"
export * from "./radarChar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271bf2b9",
  null
  
)

export default component.exports